var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var modal = require('../../layout/components/modal');
var formGroup = require('../../components/formGroup');
var fieldnetTree = require('../../network/components/fieldnetTree');
var buttonElement = require('../../components/button');
var pointTd = require('../../data/components/pointTd');
var loaders = require('../../layout/components/loaders');
var { evaluateFormula } = require('../libs/formulaSandbox');
var serviceModel = require('../../service/models/service');
var serviceTaxonomy = require('../../service/serviceTaxonomy');
var serviceClassSelect = require('../../service/components/serviceClassSelect');

var editFeedsModal = Object.assign(Object.create(Model), require('../../../../../models/equipment/feeds'));

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});

editFeedsModal.editDialogue = async function (record, options) {
  serviceTaxonomy.normalizeFeed(record);
  record.fromNode = record.from;
  record.toNode = record.to;
  record['@rid'] = record.key;
  editFeedsModal.initForm.call(editFeedsModal, record);
  editFeedsModal.form.serviceClass(editFeedsModal.form.serviceClass() || editFeedsModal.form.category());

  await serviceModel.getClassTree().catch(function () {
    return null;
  });

  if (editFeedsModal.form.fromNode().includes('Port')) {
    editFeedsModal.form.fromNode(record.equipmentDiagramRid);
  }

  if (editFeedsModal.form.toNode().includes('Port')) {
    editFeedsModal.form.toNode(record.equipmentDiagramRid);
  }

  //Custom fields to test the formula
  editFeedsModal.form.formulaValue = prop('');

  //Temporal Map for Points Rids
  const pointRecords = editFeedsModal.form.pointsLinked() || [];

  const columns = await Promise.all(
    pointRecords.map(async (pointRecord) => {
      const pointData = await loaders.requestWithLoader({
        loader: 'main',
        url: `/api/v1/point/${pointRecord.rid.slice(1)}/resource`,
        method: 'GET',
      });

      return {
        in: {
          '@rid': pointRecord.rid,
          id: pointRecord.id,
          path: pointData.path
        },
      };
    })
  );

  editFeedsModal.form.columns = columns;
  // Adding the new Point 
  editFeedsModal.showFielnetTree = prop(false);
  editFeedsModal.newPointToAdd = prop(null);

  editFeedsModal.errors = [];

  // Section state
  editFeedsModal.propertiesSectionOpen = prop(true);
  editFeedsModal.diagramSectionOpen = prop(false);
  editFeedsModal.advancedSectionOpen = prop(false);

  var submit = function () {
    // Clear previous errors
    editFeedsModal.errors = [];

    // Check if a function is defined but there are no points
    if (editFeedsModal.form.formula()?.trim().length > 0 && (!editFeedsModal.form.columns || editFeedsModal.form.columns.length === 0)) {
      editFeedsModal.errors.push("You must define at least one point before setting a function.");
      return;
    }

    // Test from formula
    if (editFeedsModal.form.formula()?.trim().length > 0 && !editFeedsModal.testFormula()) {
      console.error("Formula test failed. Stopping execution.");
      return;
    }

    // Update linked points
    editFeedsModal.form.pointsLinked(
      editFeedsModal.form.columns.map(c => {
        return {
        rid: c.in['@rid'],
        id: c.in.id
        }
      }
      ))

    editFeedsModal.form.serviceClass(editFeedsModal.form.serviceClass() || editFeedsModal.form.category());
    editFeedsModal.form.category(editFeedsModal.form.serviceClass());

    return editFeedsModal.save()
      .then(function (data) {
        options && options.submitCallback ? options.submitCallback() : '';
        key.unbind('enter');
        modal.vm.close();
      })
  };

  key.setScope('modal');
  key('enter', 'modal', submit);
  modal.vm.title('Edit Feeds Edge');
  modal.vm.body = editFeedsModal.view,
    modal.vm.buttons((options && options.delete ? [
      {
        label: "Delete",
        class: "dib mr2 red",
        func: function () {
          return editFeedsModal.delete(record)
            .then(function () {
              options && options.submitCallback ? options.submitCallback() : '';
              key.unbind('enter');
              modal.vm.close();
            })
            .catch(function (err) {
              console.error('Unable to delete feed edge', err);
              editFeedsModal.errors = editFeedsModal.errors || [];
              editFeedsModal.errors.push('Unable to delete connection right now.');
              m.redraw();
            });
        }
      }
    ] : []).concat([
      {
        label: "Save",
        class: record ? "dib mr2 green" : "btn-good",
        func: submit
      }
    ]));

  modal.vm.open();
}

editFeedsModal.testFormula = function () {
  // Clear previous errors
  editFeedsModal.errors = [];

  const formula = editFeedsModal.form.formula()?.trim();
  const points = editFeedsModal.form.columns.map((column) => {
    return column.in;
  });

  if (!formula) return;

  // Check if a function is defined but there are no points
  if (formula && (!editFeedsModal.form.columns || editFeedsModal.form.columns.length === 0)) {
    editFeedsModal.errors.push("You must define at least one point before setting a function.");
    return;
  }


  try {
    // Ensure function is well-formed
    const testFunc = new Function(`return (${formula})`)();

    // Ensure it's actually a function
    if (typeof testFunc !== "function") {
      throw new Error("Formula must be a valid function.");
    }

    // Ensure it contains a return statement
    const functionString = testFunc.toString();
    if (!functionString.includes("return")) {
      throw new Error("Function must contain a 'return' statement.");
    }

    // Extract the number of parameters from the function
    const paramMatch = functionString.match(/\(([^)]*)\)/); // Extract parameters inside `()`
    const paramList = paramMatch ? paramMatch[1].split(',').map(p => p.trim()).filter(p => p) : [];
    const expectedParams = paramList.length;

    // Ensure the number of points matches the function parameters
    if (expectedParams !== points.length) {
      throw new Error(`Function expects ${expectedParams} parameters, but ${points.length} points are defined.`);
    }

    const result = evaluateFormula(formula, points.map(p => p.value));

    // Store the result
    editFeedsModal.form.formulaValue(result);

    return true; // No errors, function executed successfully
  } catch (err) {
    editFeedsModal.errors.push(`Invalid JavaScript function: ${err.message}`);
    return false; // Stop execution
  }

};

editFeedsModal.view = function () {
  return m('form', { role: 'form' }, [
    editFeedsModal.errorView(),

    ['Properties', 'Diagram', 'Advanced'].map((sectionName, index) =>
      collapsibleSection({
        index,
        title: sectionName,
        isOpen: getSectionOpenProp(sectionName),
        toggle: () => getSectionOpenProp(sectionName)(!getSectionOpenProp(sectionName)()),
        content: renderFieldsForSection(sectionName)
      })
    )
  ]);
};

function getSectionOpenProp(sectionName) {
  switch (sectionName) {
    case 'Properties': return editFeedsModal.propertiesSectionOpen;
    case 'Diagram': return editFeedsModal.diagramSectionOpen;
    case 'Advanced': return editFeedsModal.advancedSectionOpen;
    default: return prop(false);
  }
}

function renderFieldsForSection(sectionName) {
  return Object.entries(editFeedsModal.fields)
    .filter(([key, value]) => value.section === sectionName)
    .map(([key]) => {
      if (key === 'category') return null;
      if (key === 'pointsLinked') return renderPointsLinked();
      if (key === 'formula') return renderFormulaField();
      if (key === 'minValue' || key === 'maxValue') return null; // We'll render them together
      if (key === 'serviceClass') return renderServiceClassField();
      return renderTextField(_.startCase(key), key);
    })
    .concat(sectionName === 'Diagram' ? renderMinMaxFields() : []); // only add Min/Max together in Advanced
}

function renderServiceClassField() {
  return m(formGroup, [
    m('label', 'Service Class'),
    m(serviceClassSelect, {
      class: 'form-control',
      includeBlank: true,
      value: editFeedsModal.form.serviceClass() || editFeedsModal.form.category() || '',
      onchange: function (value) {
        editFeedsModal.form.serviceClass(value);
        editFeedsModal.form.category(value);
      }
    })
  ]);
}

function collapsibleSection({ title, isOpen, toggle, content, index }) {
  return m(`div.w-100.bw1.bb.pv2${index === 0 ? '.bt' : ''}`, [
    m('div.w-100.flex.justify-between.items-center', { onclick: toggle }, [
      m('p.f3.ma0', title),
      m(`i.f1.blue.ion-ios-arrow-${isOpen() ? 'up' : 'down'}`)
    ]),
    m('div.w-100.pt2.pb3', { style: { display: isOpen() ? 'block' : 'none' } }, content)
  ]);
}

function renderTextField(label, fieldName, readOnly = false) {
  return m(formGroup, [
    m('label', label),
    m('input.form-control', {
      type: 'text',
      readonly: readOnly,
      value: editFeedsModal.form[fieldName](),
      oninput: !readOnly ? ev => editFeedsModal.form[fieldName](ev.target.value) : undefined
    })
  ]);
}

function renderFormulaField() {
  return m('div', [
    m(formGroup, [
      m('label', 'Formula (JavaScript Code):'),
      m('textarea.h4.mb2', {
        style: { resize: 'none' },
        rows: 5,
        value: editFeedsModal.form.formula(),
        oninput: ev => editFeedsModal.form.formula(ev.target.value),
        placeholder: 'Add JavaScript function here...'
      })
    ]),
    m('div.flex.items-center.mb2', [
      m('div.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.pointer.mr2.nowrap', {
        onclick: editFeedsModal.testFormula
      }, 'Test Formula'),
      m('input.form-control', { readonly: true, value: editFeedsModal.form.formulaValue() })
    ])
  ]);
}

function renderMinMaxFields() {
  return m('div.flex.justify-between.mb2', [
    m('div.w-50.mr2', [
      m('label', 'Min Value'),
      m('input.form-control', {
        type: 'text',
        value: editFeedsModal.form.minValue(),
        oninput: ev => editFeedsModal.form.minValue(ev.target.value)
      })
    ]),
    m('div.w-50', [
      m('label', 'Max Value'),
      m('input.form-control', {
        type: 'text',
        value: editFeedsModal.form.maxValue(),
        oninput: ev => editFeedsModal.form.maxValue(ev.target.value)
      })
    ])
  ]);
}

function renderPointsLinked() {
  return [
    m('div.f3.pv2', 'Points Linked'),
    m('div.w-100.pt2.pb3', [
      m('div.flex.w-100.mb1', [
        m('div.tc.v-btm.fw2.bw1.ph2', { style: { width: '20%' } }, m('p.ma0.tc.truncate', 'Rid')),
        m('div.tc.v-btm.fw2.bw1.ph2', { style: { width: '50%' } }, m('p.ma0.tc.truncate', 'Path')),
        m('div.tc.v-btm.fw2.bw1.ph2', { style: { width: '10%' } }, m('p.ma0.tc.truncate', 'Id')),
        m('div.tc.v-btm.fw2.bw1.ph2', { style: { width: '10%' } }, m('p.ma0.tc.truncate', 'Value')),
        m('div.tc.v-btm.fw2.bw1.ph2', { style: { width: '10%' } }, '') // Empty column for delete button
      ]),
      editFeedsModal.form.columns.map((columnRecord, idx) => {
        columnRecord.in.id = String.fromCharCode(65 + idx);
        return m('div.flex.items-center.mb1', [
          m('div.mr1.w-20', [
            m('input.form-control', {
              type: 'text',
              oninput: function (ev) { columnRecord.in['@rid'] = ev.target.value; },
              value: columnRecord.in['@rid'],
            })
          ]),
          m('div.mr1.w-50.ph2', [
            (columnRecord.in.path || []).map(function (ancestor, idx) {
              return m('div.dib.mr1', [
                m('div', `${ancestor.name}${idx < (columnRecord.in.path.length - 1) ? ' /' : ''}`)
              ]);
            })
          ]),
          m('div.mr1.w-10', [
            m('input.form-control', {
              type: 'text',
              value: columnRecord.in.id,
              disabled: true,
            })
          ]),
          m('div.w-10.flex.justify-center', {
            style: {
              pointerEvents: 'none'
            }
          }, [
            m(pointTd, {
              columnRecord: columnRecord,
              textAlign: 'center',
              options: {
                skipEditCheck: true,
                keepPollingOnModalOpen: true
              }
            })
          ]),
          m('div.w-10', [
            m(buttonElement, {
              class: 'w3 fr',
              label: m('i.f4.ion-ios-trash.red'),
              func: function () {
                editFeedsModal.form.columns.splice(idx, 1);
              }
            })
          ])
        ]);
      }),
      editFeedsModal.showFielnetTree() ?
        m('div', [
          m(fieldnetTree, { selectedPoint: editFeedsModal.newPointToAdd }),
          m('div.w-100.cf', {
            style: {
              visibility: editFeedsModal.newPointToAdd() ? 'visible' : 'hidden'
            }
          }, [
            m(buttonElement, {
              class: 'fr green mv2',
              label: [
                m('i.ion-plus.mr1'),
                'Confirm Point'
              ],
              func: async function () {
                let pointData = await loaders.requestWithLoader({
                  loader: 'main',
                  url: `/api/v1/point/${editFeedsModal.newPointToAdd().slice(1)}/resource`,
                  method: 'GET',
                });
                editFeedsModal.form.columns.push(
                  { 
                    in: { 
                      '@rid': editFeedsModal.newPointToAdd(), 
                      id: editFeedsModal.newPointToAdd.id,
                      path: pointData.path
                    } 
                  }
                );
                editFeedsModal.showFielnetTree(false);
              }
            })
          ])
        ])
        : '',
      editFeedsModal.form.columns.length < 4 && !editFeedsModal.showFielnetTree() ?
        m('div.w-100.cf', [
          m(buttonElement, {
            class: 'fr blue mv2',
            label: [
              m('i.ion-plus.blue.mr1'),
              'Add Point'
            ],
            func: function () {
              editFeedsModal.showFielnetTree(true);
            }
          })
        ])
        :
        m('div', '')
    ])
  ]
}


module.exports = editFeedsModal;
